export default __webpack_public_path__ + "static/media/resources-background.31fab20f.svg";